<template>

  <div>

    <div class="columns" style="margin-top:20px;">

      <div class="column">
        <div style="display:flex;">
          <b-autocomplete
              v-model="firmName"
              :placeholder="canManageFirm ? 'Select or Create Firm' : 'Select Firm'"
              :data="showNotFirmFirm"
              field="name"
              style="min-width:350px;">
          </b-autocomplete>

          <button class="button is-info" :disabled="(!firmName || !addFirmFirm) && (!firmName || !canManageFirm)" @click.prevent="add">Add</button>
          
        </div>

      </div>

      <div class="column">
        
        <button type="button" @click="archived = !archived" class="button archived-button">{{ archived ? 'HIDE ARCHIVED' : 'SHOW ARCHIVED'  }}</button>

      </div>
      
    </div>

    <div class="columns">
    
      <div class="column is-12" style="position: relative">

        <table class="table is-fullwidth">

          <tr v-for="firm in firmList" :key="firm.id">
  
            <td class="is-narrow">{{ firm.firm.name }}</td>

            <td class="">

              <button class="button is-small rate-button" type="button" @click="openRate(firm.firm)" v-if="!ratings(firm.firm) && canRate">Rate</button>

              <star-rating class="mb-1" :increment ="0.1" :rating="ratings(firm.firm)" :star-size="20" :show-rating="false" read-only />
              
            </td>
            
            <td class="is-narrow">  
    
              <button class="button is-warning is-small" @click.prevent="archive(firm.firm, $event)" v-if="!firm.archived_at">ARCHIVE</button>

              <button class="button is-dark is-small" @click.prevent="restore(firm.firm, $event)" v-else>RESTORE</button>
            
              <button :class="(hasTag(firm.firm.id, tag) ? ' is-info' : '') + ' button tags-button is-small'" 
              
              :disabled="firm.archived_at" v-for="(tag, key) in firmTags" 

              @click.prevent="firmTag(firm.firm, tag, $event)"  >{{ tag.name }}</button>
    
            </td>

          </tr>

          </tr>
          
        </table>

        <div v-if="!firmList.length">

          <p class="no-firm-firm">No Associated Firm</p>
        
        </div>

        <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="false"></b-loading>

      </div>
    
    </div>

    <b-modal :active.sync="modal.active" has-modal-card>

      <rating-modal :rate="rate" />
    
    </b-modal>

    <br>

  </div>

</template>

<script>

import { TagService } from "@/services/tag.service";

import { FirmService } from "@/services/firm.service";

import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

import StarRating from "vue-star-rating";

import RatingModal from "@/components/Rating/RatingModal";

export default {

  components: {

    StarRating,

    RatingModal

  },

  data: () => ({
    firmService: FirmService,
    firms: [],
    loading: false,
    data: {
      children: []
    },
    firmTags: [],

    selectedtags: [],

    archived: false,

    notFirmFirm: [],

    firmName: '',

    modal: {

      active: false
    
    },

    firmIdModal: '',

    addFirmFirm: true

  }),
  props: {
    children: {
      type: Array,
      default: []
    },
    organization: {
      type: Object,
      default: []
    }
  },
  watch: {
    "data.children"() {
      this.$parent.form.children = this.data.children;
    },
    children(value) {
      this.data.children = value;
    },

    organization() {
        
        this.selectedTag();
        this.getNotFirmFirm();

    },

    firmName(value) {

      this.addFirmFirm = this.showNotFirmFirm.filter(element => {return element.name.toLowerCase() == value.toLowerCase() }).length ? true : false;

    }

  },
  mounted() {
    this.data.children = this.children;
    this.fetch();
    this.getTags();
    this.getNotFirmFirm();
    this.selectedTag();
  },
  methods: {
    async fetch() {
      try {
        
        this.loading = true;
        
        const response = await this.firmService.all({ archived: false, organization_id: this.organization.id });

        this.firms = JsonDenormalizer.denormalize(response);
        
        this.loading = false;
      
      } catch (err) {
      
        this.loading = false;
     
      }
    
    },

    getTags() {

      TagService.findtags({tags: ['customer', 'vendor']}).then(response => {

        this.firmTags = JsonDenormalizer.denormalize(response);

      });

    },


    getNotFirmFirm() {

      FirmService.notFirmFirm({firm_id: this.organization.id}).then(response => {

        this.notFirmFirm = JsonDenormalizer.denormalize(response);

      });

    },


    firmTag(firm, tag, event) {

        event.target.classList.toggle('is-info');

        event.target.classList.toggle('is-loading');

        TagService.attachtag({tag: tag.id, parent_id: this.organization.id, child_id: firm.id}).then(response => {

            this.data.children = response;
            
            event.target.classList.toggle('is-loading');

        });

    },

    selectedTag() {

        TagService.selectedtags({firm_id: this.organization.id}).then(response => {

            this.selectedtags = response;

        });

    },

    hasTag(firm_id, tag) {

        let selectedtags = this.selectedtags;

        let active = false;

        Object.keys(this.selectedtags).forEach(function (item) {

            if (selectedtags[item].child_id == firm_id) {

                selectedtags[item].tags.forEach(element => {

                    if (element.pivot.archived_at == null) {
                        
                        if (element.id == tag.id) {

                            active = true;

                        }

                    }

                });

            }
        
        });

        return active;

    },

    activeParent(firm) {

        let active = false;

        this.children.forEach(element => {

            if (firm.id == element) {

                active = true;
            
            }

        });

        return active;

    },

    archive(firm, event) {

      event.target.classList.toggle('is-loading');

      TagService.toggleArchived({child_id: firm.id, parent_id: this.organization.id}).then(response => {

          this.selectedtags = response;
          
          event.target.classList.toggle('is-loading');

      });

    },

    restore(firm, event) {

      event.target.classList.toggle('is-loading');

      TagService.toggleArchived({child_id: firm.id, parent_id: this.organization.id}).then(response => {

          this.selectedtags = response;
          
          event.target.classList.toggle('is-loading');

      });

    },

    add() {

      if (this.canManageFirm) {
        
        FirmService.attachOrCreate({firm_id: this.organization.id, keyword: this.firmName}).then(response => {

            this.selectedtags = response;

            this.firmName = '';

        });

      }

    },

    ratings(firm) {

      return firm.ratings.length ? firm.ratings[0].rating : 0;
     
    },


    async rate(data) {

      await FirmService.rate(this.firmIdModal, data).then(response => {

        this.selectedTag();

      });

    },

    openRate(firm) {

      this.firmIdModal = firm.id;

      this.modal.active = true

    }

  },

  computed: {

    firmList() {

      let selectedtags = this.selectedtags;
      
      // Filter tags with firm
      // Tags without firm causes 'property' of undefined error.
      selectedtags = selectedtags.filter(tag => tag.firm);

      if (this.archived) {

        return selectedtags;
        
      }

      return selectedtags.filter(element => {

        return element.archived_at == null;

      });

    },

    showNotFirmFirm() {

       return this.notFirmFirm.filter(firm => {

          return firm.name.toString().toLowerCase().includes(this.firmName.toLowerCase())
      
      })

    },

    canRate() {
      
      return this.$store.getters["Auth/hasFirmPermission"]("can rate firms")
    
    },

    canManageFirm() {

      return this.$store.getters["Auth/hasPermission"]("can manage firms")
      return false;

    }


  }

};
</script>


<style scoped>

.tags-button{
    margin: 0px 5px;
}

.archived-button {

  float: right;
  margin-right: 15px;

}

.no-firm-firm{
  text-align: center;
}

.rate-button{
  
  position: absolute;
  margin-left: 115px;
  margin-top: 2px;

}

</style>


// WEBPACK FOOTER //
// src/components/pages/Users/list-new/partials/associatedOrganizations.vue